import type { GameView } from '@/shared/game/types'

/**
 * Видна ли история разговора.
 *
 * За закрытым столом — да: туда попадают по ссылке или по приглашению друга,
 * и разговор знакомых людей имеет смысл перечитывать.
 *
 * За открытым — нет. Быстрая игра сажает рядом незнакомцев, и список того,
 * что они друг другу наговорили, никому из них не нужен: сказать там можно
 * только готовой фразой, а фраза — это реакция на ход, а не переписка.
 * Поэтому за открытым столом остаётся только возможность СКАЗАТЬ, а сказанное
 * видно там, где оно и уместно, — плашкой у двора говорившего (useSpeech),
 * несколько секунд.
 *
 * Тем же флагом отделяется свободный текст (ChatService::write): и то и
 * другое — про то, кто за столом сидит.
 */
export function showsHistory(view: GameView): boolean {
  return view.visibility === 'private'
}

/**
 * Можно ли писать свободным текстом.
 *
 * Признак тот же, что у истории, и это не совпадение: и то и другое про то,
 * кто за столом сидит. Свободный текст между незнакомцами — это мат в первой
 * же партии и модерация, которой в проекте нет; готовая фраза такого не
 * создаёт вовсе, сказать ею можно только то, что мы сами написали.
 *
 * Отдельным именем, а не одним на оба случая: причины разные, и разъехаться
 * им лучше здесь, чем по всему экрану. Правило всё равно проверяет сервер
 * (ChatService::write) — прятать поле мало, на ручку ходят и мимо интерфейса.
 */
export function allowsFreeText(view: GameView): boolean {
  return view.visibility === 'private'
}

/**
 * Есть ли чату что показать этому человеку.
 *
 * За открытым столом зритель со стороны не получает ничего: истории там нет,
 * а писать он не может — значит и кнопки ему не нужно.
 */
export function hasChat(view: GameView): boolean {
  return showsHistory(view) || view.you !== null
}
